<template>
    <el-dialog
        class="add"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Add"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form ref="addForm" :model="addForm" @keydown.enter.native.prevent>
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="Rank"
                            prop="rank"
                            size="small"
                        >
                            <el-input
                                clearable
                                size="small"
                                v-model="addForm.rank"
                                placeholder="Rank"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Discount" prop="discount" size="small">
                            <el-input
                                clearable
                                size="small"
                                v-model="addForm.discount"
                                placeholder="Discount"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="24">
                        <el-form-item label="Mobile" prop="mobile" size="small">
                            <el-input
                                clearable
                                size="small"
                                v-model="addForm.mobile"
                                placeholder="Mobile"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Status" size="small" prop="status">
                            <el-radio-group v-model="addForm.status">
                                <el-radio :label="1">Valid</el-radio>
                                <el-radio :label="2">Invalid</el-radio>
                                <el-radio :label="3">Pending</el-radio>
                                <el-radio :label="4">Close</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col> -->
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >Save</el-button
            >
            <el-button size="small" @click="addVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapActions } from "vuex";
export default {
    data() {
        return {
            addForm: {
                rank: "",
                discount: "",
            },
        };
    },
    methods: {
        save() {
            this.loading = true;
            cmofferApi
                .entityRank(
                    {
                        ...this.addForm,
                    },
                    "post"
                )
                .then((res) => {
                    this.loading = false;
                    this.closeDialog();
                    this.$message.success(
                        this.$i18n.locale == "zh" ? "成功" : "Success"
                    );
                    this.$parent[this.funcName]();
                });
        },
        closeDialog() {
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.$emit("update:addVisible", false);
        },
    },
    props: {
        addVisible: Boolean,
        funcName: String
    },
    watch: {
        addVisible() {
            if (this.addVisible) {
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.add {
    ::v-deep .container {
        .el-input {
            & + .el-input {
                margin-top: 10px;
            }
        }
        .el-select {
            width: 100%;
        }
        .el-form-item--small {
            margin-bottom: 5px !important;
        }
        .el-checkbox__label {
            font-size: 12px;
        }
        .el-radio-group {
            width: 100%;
        }
    }
}
</style>
